import { NoImage } from "@assets/constant/index.constant";
import { PlayButton } from "@assets/icons";
import { Switch } from "@components/ui/switch";
import { endpoint } from "@services/api.services";
import Tooltip from "@ui/external/components/tooltip";
import { UserProfile } from "@ui/internal/components/card";
import { ZoomImage } from "@ui/internal/components/formelement";
import { formatDateTime } from "@utils/helper/index.helper";
import { useHandleAction } from "@utils/hook/index.hook";
import { usePreviewVideo, useSelectionStore } from "@utils/states/index.state";
import { useMemo } from "react";
import { NavLink } from "react-router";

const ColumnList = ({
  refetch,
  toggleActiveStatus,
}: {
  refetch?: () => void;
  toggleActiveStatus: (id: string | number, state: boolean) => void;
}) => {
  const TestimonialEndpoint = useMemo(() => endpoint["testimonial"], []);
  const { clearSelection } = useSelectionStore();
  const { handleAction } = useHandleAction({
    endpoint: TestimonialEndpoint,
    refetch,
  });
  const { setPreviewVideo } = usePreviewVideo();
  const columns = useMemo(
    () => [
      {
        name: "ID",

        cell: (row: any) => (
          <span className="font-semibold text-gray-700">{row.id}</span>
        ),
        sortable: true,
      },
      {
        name: "Created Date",
        accessKey: "created_date",
        cell: (row: any) => {
          return (
            <span className="font-semibold text-gray-700">
              {row.updated_date
                ? formatDateTime(row?.updated_date)
                : formatDateTime(row?.created_date)}
            </span>
          );
        },
        sortable: true,
      },
      {
        name: "Name & Role",

        cell: (row: any) => {
          return (
            <div className="flex  max-w-[250px] w-fit justify-start  ">
              <UserProfile
                userimage={row.image || NoImage}
                userdesignation={row?.role}
                username={row.name}
              />
            </div>
          );
        },
        sortable: false,
      },
      {
        name: "Description / Video",
        cell: (row: any) => {
          return (
            <div className="flex  max-w-[250px] w-fit h-full">
              {row?.testimonial_type == "video" ? (
                row?.video && (
                  <div className="flex gap-2 items-center">
                    <video
                      onClick={() => setPreviewVideo(row?.video)}
                      src={row?.video}
                      className="w-12 h-12 object-cover cursor-pointer rounded"
                    />
                    <span
                      className="text-[#1DA077] cursor-pointer flex gap-2 items-center text-[14px]"
                      onClick={() => setPreviewVideo(row?.video)}
                    >
                      <PlayButton color="#1DA077" /> Play Video
                    </span>
                  </div>
                )
              ) : (
                <p
                  className="line-clamp-2 max-w-[350px] w-fit"
                  dangerouslySetInnerHTML={{ __html: row?.description }}
                ></p>
              )}
            </div>
          );
        },
        sortable: true,
      },

      {
        name: "Actions",
        cell: (row: any) => (
          <div className="flex items-center gap-3 cursor-pointer font-[500] select-none">
            <Switch
              defaultChecked={row?.is_show}
              onCheckedChange={(value) => toggleActiveStatus(row?.id, value)}
              className="cursor-pointer"
            />
            <NavLink
              to={`/testimonials?tab=${row.testimonial_type}&page=edit&page-item=${row.id}`}
            >
              <button
                className="text-[#1DA077] cursor-pointer"
                title="Edit"
                type="button"
              >
                Edit
              </button>
            </NavLink>
            <button
              className="text-[#C33241] cursor-pointer"
              onClick={() => {
                clearSelection();
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row.id },
                });
              }}
              title="Delete"
            >
              Delete
            </button>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction, clearSelection, setPreviewVideo, toggleActiveStatus]
  );
  return columns;
};

export { ColumnList };
